import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import { MapPin } from "lucide-react";

const ROWS = [
  {
    id: "chiffons",
    title: "The Chiffons",
    role: "Touring Background Vocalist",
    scope: "National Tour / Select Dates",
    years: "2011–2012",
    desc: "Performed classic 1960s girl-group hits, executing tight three-part harmonies and synchronized stage movement for national concert audiences.",
    tags: ["Three-Part Harmonies", "Synchronized Stage Movement", "60s Girl-Group Classics"],
  },
  {
    id: "montell-jordan",
    title: "Montell Jordan",
    role: "Touring Background Vocalist",
    scope: "Regional Tour",
    years: "2012",
    desc: "Delivered dynamic live backing vocals and harmonies across classic 90s R&B, contemporary soul, and gospel arrangements.",
    tags: ["90s R&B", "Contemporary Soul", "Gospel Arrangements"],
  },
  {
    id: "nyc-resident",
    title: "Solo Acoustic Resident",
    role: "Self-Accompanied — Rhythm Guitar & Vocals",
    scope: "New York, NY",
    years: "Ongoing",
    desc: "Maintained sustained live performance residencies across diverse NYC venues, lounges, and private showcases. Built and delivered high-engagement, multi-hour acoustic sets spanning Top 40, Motown, R&B, soul, gospel, and acoustic pop.",
    tags: ["Top 40", "Motown", "R&B / Soul", "Gospel", "Acoustic Pop"],
  },
];

export default function Touring() {
  return (
    <section id="credits" className="relative py-24 lg:py-32" data-testid="touring-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
        <SectionHeading
          index="02"
          eyebrow="Professional Touring & Live Performance"
          title="National Tours & Residencies"
        />
        <div className="border-t border-white/10">
          {ROWS.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.08}>
              <div
                className="group grid lg:grid-cols-12 gap-4 lg:gap-8 border-b border-white/10 py-8 lg:py-10 px-1 sm:px-3 transition-colors duration-300 hover:bg-white/[0.03]"
                data-testid={`touring-row-${r.id}`}
              >
                <div className="lg:col-span-5">
                  <div className="flex items-baseline gap-4">
                    <span className="font-mono text-xs text-hpink">0{i + 1}</span>
                    <div>
                      <h3 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight group-hover:text-hpink transition-colors duration-300">
                        {r.title}
                      </h3>
                      <p className="mt-1 text-sm text-hblue font-semibold">{r.role}</p>
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-3 font-mono text-[11px] uppercase tracking-[0.2em] text-hdim flex lg:flex-col gap-2 lg:gap-1.5">
                  <span className="flex items-center gap-1.5">
                    <MapPin size={11} className="text-horange" /> {r.scope}
                  </span>
                  <span className="text-white">{r.years}</span>
                </div>
                <div className="lg:col-span-4">
                  <p className="text-sm sm:text-base text-hmut leading-relaxed">{r.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {r.tags.map((t) => (
                      <span key={t} className="rounded-full border border-white/12 bg-white/5 px-3 py-1 text-[11px] text-white/80">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
